var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2849 11.2951C14.207 11.1398 14.0484 11.0417 13.8747 11.0417H12.958V6.45833C12.958 6.20533 12.7531 6 12.4997 6C12.2462 6 12.0414 6.20533 12.0414 6.45833V11.0417H11.1247C10.951 11.0417 10.7924 11.1397 10.7145 11.2951C10.6375 11.4505 10.654 11.6361 10.758 11.775L12.133 13.6083C12.139 13.6161 12.1482 13.6189 12.1546 13.6262C12.1848 13.6619 12.2206 13.6894 12.2605 13.7146C12.277 13.7247 12.2898 13.738 12.3077 13.7463C12.3663 13.7738 12.4305 13.7916 12.4997 13.7916C12.5689 13.7916 12.6331 13.7738 12.6922 13.7463C12.7096 13.738 12.7229 13.7247 12.739 13.7146C12.7788 13.6894 12.8146 13.6619 12.8448 13.6262C12.8508 13.6189 12.8604 13.6161 12.8664 13.6083L14.2414 11.775C14.3459 11.6361 14.3624 11.4505 14.2849 11.2951Z",
    fill: "#00A094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5417 12.875C17.2882 12.875 17.0833 13.0803 17.0833 13.3333V14.7083C17.0833 15.4664 16.4664 16.0833 15.7083 16.0833H9.29167C8.5336 16.0833 7.91667 15.4664 7.91667 14.7083V13.3333C7.91667 13.0803 7.7118 12.875 7.45835 12.875C7.20487 12.875 7 13.0803 7 13.3333V14.7083C7 15.972 8.02805 17 9.29167 17H15.7083C16.972 17 18 15.972 18 14.7083V13.3333C18 13.0803 17.7951 12.875 17.5417 12.875Z",
    fill: "#00A094"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    stroke: "#00A094",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e55fb5e9253f90ef00d74e0f76b15300.svg";
export { ForwardRef as ReactComponent };